import { Component, computed, HostBinding, input, model, output, viewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { isNumber } from 'lodash';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-datepicker',
  templateUrl: './pan-datepicker.component.html',
  styleUrl: './pan-datepicker.component.scss',
  standalone: false,
})
export class PanDatepickerComponent {
  public color = input<ThemeColor>('default');
  public disabled = input<boolean>(false);
  public min = input<Date | number>();
  public max = input<Date | number>();
  public name = input<string>();
  public placeholder = input<string>();
  public defaultValue = input<string>();
  public id = input<string>();
  public startView = input<'month' | 'year' | 'multi-year'>('month');

  public monthSelected = output<{ date: Date; datePicker: MatDatepicker<Date> }>();
  public yearSelected = output<{ date: Date; datePicker: MatDatepicker<Date> }>();
  public invalidDate = output<void>();

  public datePickerElement = viewChild<MatDatepicker<Date>>('datePicker');

  public date = model<string | Date>();

  public onDateChange(event: MatDatepickerInputEvent<Date>): void {
    const inputEl = event.targetElement as HTMLInputElement;
    if (inputEl.value && event.value === null) {
      this.invalidDate.emit();
    }
  }

  public realMinDate = computed(() => (isNumber(this.min()) ? new Date(this.min()) : this.min()));
  public realMaxDate = computed(() => (isNumber(this.max()) ? new Date(this.max()) : this.max()));

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  public classes = computed(() => {
    return ['datepicker', `datepicker-color-${this.color()}`, this.disabled() ? 'datepicker-disabled' : ''].filter(Boolean);
  });
}
